import { useQuery } from "react-query";
import { DateTime } from 'luxon';
import _ from 'lodash';
import isEqual from 'react-fast-compare';
import { createDecorator } from '../../../components/form';
import { Sale, SaleBase, VatCode } from '../types';
import { calculateLineAmounts, calculateTotalAmounts } from '../invoiceHelpers';
import { fetchVatCodes, filterVatCodes } from '../../../components/select/VatCodeSelect';
import { fetchSaleItems } from '../apiActions';
import { useCurrentCompany } from '../../auth/CurrentCompany';
import { MutableState, Tools } from 'final-form';
import { useMemo } from "react";

const paymentTermDecorator = createDecorator({
  field: /invoiceDate|dueDate/, // when invoiceDate or dueDate changes...
  updates: (fieldValue: any, name, allValues: Sale | undefined, prevValues: Sale | undefined) => {
    if(!allValues?.invoiceDate || ! allValues?.dueDate) {
      return {
        paymentTerm: null,
      }
    }
    return {
      paymentTerm:  Math.ceil(DateTime.fromISO(allValues?.dueDate!).diff(
        DateTime.fromISO(allValues?.invoiceDate!),
        'days'
      ).days)
    }
  }
});

const itemDecorator = createDecorator({
  field: /Lines\[\d+\].*item/i, // when a field matching this pattern changes...
  updates: (value, name, allValues, prevValues) => {
    return {};
    // console.log('item decorator',name);
    // if(!value) return {};
    // if(!(prevValues as Sale)?.invoiceNumber) return {}; // fix to skip on initialValues
    // const line = name.replace('.item', '');
    //
    // return {
    //   [`${line}.name`]: value.name,
    //   [`${line}.description`]: value.description,
    //   [`${line}.price`]: value.price,
    //   [`${line}.vatCodeId`]: value.vatCodeId,
    //   [`${line}.quantity`]: 1,
    //   [`${line}.itemId`]: value.id,
    // }
  }});

const useSaleHelpers = () => {

  const currentCompany = useCurrentCompany();
  const { data: vatCodes } = useQuery(['vatCodes', true, false], fetchVatCodes, {staleTime: 1000 * 60 * 30 });
  // const { data: saleItems } = useQuery(['saleItems'], fetchSaleItems, {staleTime: 1000 * 60 * 30 });

  const values = useMemo(()=> {
    const amountsDecorator = createDecorator({
      field: 'Lines', // when a field matching this pattern changes... \[\d+\].*(?:price|quantity|vatCodeId)|invoiceDate)
      updates: (value, name, allValues: SaleBase | undefined, prevValues: Sale | undefined) => {
        // console.log(_.map(allValues?.Lines || [], 'description'));
        // console.log(_.map(prevValues?.Lines || [], 'description'));

        // ignore if only the description changes (to speed up)
        if(allValues?.Lines?.length === prevValues?.Lines?.length && !isEqual(_.map(allValues?.Lines || [], 'description'), _.map(prevValues?.Lines || [], 'description'))) {
          return {}
        }
        // console.log('amountsDecorator field',name);
        // console.log('value field',value);
        // console.log('allValues lines',allValues?.Lines);
        const sale = allValues as SaleBase;
        if (!sale) return {};
        sale.Lines = sale.Lines?.map((line) => {
            // eslint-disable-next-line no-param-reassign
            line.vatCode = vatCodes.find((vatCode: VatCode) => vatCode.id === line.vatCodeId);
            return {
              ...line,
              ...calculateLineAmounts(line, sale)
            }
          }
        );
        const newValues = {
          Lines: sale.Lines,
          ...calculateTotalAmounts(sale)
        };
        return newValues;
      }
    });



    const getDefaultVatCode = (sale: SaleBase) => {
      const filteredVatCodes = filterVatCodes(vatCodes, sale.customer, currentCompany.vatPeriod);
      const defaultVatCode = filteredVatCodes[0];
      return defaultVatCode;
    };

    const defaultVatCodeDecorator = createDecorator({
      field: /(customer)/i,
      updates: (value, name, allValues: SaleBase | undefined, prevValues: SaleBase | undefined) => {
        if(!allValues) return {};
        if (!prevValues?.Lines) return {}; // fix to skip on initialValues
        const filteredVatCodes = filterVatCodes(vatCodes, allValues.customer, currentCompany.vatPeriod);
        const defaultVatCode = filteredVatCodes[0];

        const Lines = (allValues as SaleBase)?.Lines?.map(line => {
          if(line.vatCodeId) {
            const itemVatCodeIdIsValid = !!filteredVatCodes.find(vatCode => vatCode.id === line.vatCodeId);
            if(itemVatCodeIdIsValid) return line; // keep vatCodeId if the vatCodeId is in the filtered vat codes
          }
          return {...line, vatCode: defaultVatCode, vatCodeId: defaultVatCode.id}
        });

        return {
          Lines
        };
      }
    });
    return {
      decorators: [paymentTermDecorator, itemDecorator, amountsDecorator, defaultVatCodeDecorator],
        getDefaultVatCode,
        vatCodes
    };
  },[vatCodes, currentCompany])

  if(!vatCodes || !currentCompany) return {};

  console.log('new sale helpers');
  return values
};

export default useSaleHelpers;
